import classes from "./css/navigation.module.css"
import logo from "../../assets/images/logo/logo.png"
import { Link } from "react-router-dom"
const NavLogo =()=>{
    return(
        <div className={classes.NavLogo}>
            <Link to="/"><img src={logo} alt="vivek" /></Link>
        </div>
    )
}


export default NavLogo